import { Controller } from 'stimulus'
import CableReady     from 'cable_ready'
import consumer       from 'channels/consumer'

export default class extends Controller {

  static targets = ['message']

  // ACTION CABLE INITIALISATION
  initialize() {
    const quote   = this.data.get("quote")
    const channel = this.data.get("channel")
    this.params   = { channel, quote }
  }

  connect() {
    const setOwners = this._setOwners.bind(this)

    setOwners()
    this.subscription = consumer.subscriptions.create(this.params, {
      received (data) {
        if (data.cableReady) CableReady.perform(data.operations)

        setOwners()
      }
    })
  }

  disconnect() {
    this.subscription.unsubscribe()
  }

  _setOwners() {
    const currentUser = this.data.get("user")

    this.messageTargets.forEach(message => {
      if (message.dataset.author == currentUser) message.classList.add("owned")
    })
  }
}
